import React from "react"
import styled from "styled-components"
import OptionsStartFinish from "./options-start-finish"
import OptionsRoomSelection from "./options-room-selection"
import OptionsItinerary from "./options-itinerary"
import OptionsExtras from "./options-extras"
import { getRoomTypes } from "./utils/roomTypes"
import OptionsPassengers from "./options-passengers"

const OptionsWrapper = styled.div`
  display: flex;
  margin-top: 48px;
`

const EmptyColumn = styled.div`
  width: 138px;
  height: 100%;

  @media (max-width: 810px) {
    display: none;
  }
`

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 138px);
  @media (max-width: 810px) {
    width: 100%;
  }
`

const Options = ({
  tourData,
  nights,
  setNights,
  rooms,
  setRooms,
  setExtras,
  setPassengers,
  optionalExtras,
}) => {
  const {
    pricingTablesNew,
    itinerary: { days: itinerary },
  } = tourData
  const roomTypes = getRoomTypes(pricingTablesNew)
  return (
    <OptionsWrapper>
      <EmptyColumn></EmptyColumn>
      <RightColumn>
        <OptionsPassengers setPassengers={setPassengers} />
        <OptionsStartFinish nights={nights} pricingTable={pricingTablesNew} />
        <OptionsRoomSelection
          roomTypes={roomTypes}
          rooms={rooms}
          setRooms={setRooms}
        />
        <OptionsItinerary itinerary={itinerary} setNights={setNights} />
        <OptionsExtras optionalExtras={optionalExtras} setExtras={setExtras} />
      </RightColumn>
    </OptionsWrapper>
  )
}

export default Options
